import html2canvas from "html2canvas";

export const storageKey = "ZGNtLWZvcm0";

export async function waitForElement(rootElementId, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const interval = 100; // Check every 100ms
    let elapsedTime = 0;

    const checkElement = setInterval(() => {
      const input = document.getElementById(rootElementId);
      if (input) {
        clearInterval(checkElement);
        resolve(input);
      } else if (elapsedTime >= timeout) {
        clearInterval(checkElement);
        reject(
          new Error(
            `Element with ID "${rootElementId}" not found within ${timeout}ms`
          )
        );
      }
      elapsedTime += interval;
    }, interval);
  });
}

export async function convertToImage(rootElementId) {
  const input = await waitForElement(rootElementId);
  const canvas = await html2canvas(input);

  return canvas.toDataURL("image/png");
}

export function removeFromAverage(average, count, oldData) {
  if (count === 1) {
    return null;
  } else {
    const total = average * count;
    return (total - oldData) / (count - 1);
  }
}

export function newAverage(average, count, newData) {
  if (count === 0) {
    return newData;
  } else {
    const total = average * count;
    return (total + newData) / (count + 1);
  }
}
